
function Header(){
    return(
        <div>
            <header>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6 boxes">
                    <h2>Showcase your app beautifully.</h2>
                    <p>Launch your mobile app landing page faster with this free, open source theme from Start Bootstrap!</p>
                    <img src="img/app-store-badge.svg" alt="" class="img-fluid"></img>
                    <img src="img/google-play-badge.svg" alt="" class="img-fluid"></img>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                    <img src="img/project.PNG" alt="" class="img-fluid img-header"></img>
                </div>
            </div>
        </div>
    </header>
        </div>
    );
}

export default Header ;